import React from 'react';
import { PropTypes } from 'prop-types';

// styles
import styled, { css } from 'styled-components';
import { media } from 'utils/style';
// components
import { CloseIcon, SettingsIcon } from 'refactored/ui/icons';
import { ResponsiveHide } from 'refactored/ui/utils';

const RowOptionsButton = ({ className, onClick, isOpened }) => {
  return (
    <button
      aria-label="Toggle Menu"
      className={className}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        onClick();
      }}
    >
      <ResponsiveHide hideMobile={isOpened}>
        <SettingsIcon />
      </ResponsiveHide>

      <ResponsiveHide hideNormal={true} hideMobile={!isOpened}>
        <CloseIcon />
      </ResponsiveHide>
    </button>
  );
};

RowOptionsButton.propTypes = {
  onClick: PropTypes.func,
  isOpened: PropTypes.bool,
  className: PropTypes.string,
};

const regularCSS = css`
  border: none;
  padding: 0;
  color: var(--white);
  width: 36px;
  max-width: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-color: ${(props) =>
    !!props.isOpened ? 'var(--grey700)' : 'var(--grey100)'};
  &:hover {
    background-color: ${(props) =>
      !!props.isOpened ? 'var(--grey700)' : 'var(--grey200)'};
  }
  svg {
    fill: ${(props) => (!!props.isOpened ? 'white' : 'var(--grey700)')};
  }
`;

const mobileCSS = css`
  background-color: var(--grey100);
  border-left: 1px solid var(--primary-200-opacity30);
  width: 72px;
  max-width: 72px;
  &:hover {
    background-color: var(--grey700);
  }
  svg {
    fill: white;
  }
`;

const StyledRowOptionsButton = styled(RowOptionsButton)`
  ${regularCSS}
  ${media.lessThan('small')`${mobileCSS}`}
`;

export default StyledRowOptionsButton;
